import React, { useContext } from 'react';
import { FormattedCurrency } from '@qover/react-intl';
import { RefsContext } from '@qover/contexts';
import type { PriceTransparencyProps } from '@qover/domain';
import { Container, Row, Separator } from './priceTransparency.styles';
import { Caption } from '@qover/typography';
import messages from './priceTransparency.messages';

const CaptionDiv = (p: any) => <Caption as="div" {...p} />;

export function PriceTransparencyInfo(props: PriceTransparencyProps) {
  const { country } = useContext(RefsContext);

  return (
    <>
      <Row style={{ paddingBottom: '10px' }}>
        <CaptionDiv className="bold">{messages.priceMentionedAbove}</CaptionDiv>
      </Row>
      <Row>
        <CaptionDiv>{messages.commercialPremium}</CaptionDiv>
        <CaptionDiv>
          <FormattedCurrency value={props.commercialPremium} />
        </CaptionDiv>
      </Row>
      {['GB', 'IT'].includes(country) && (
        <>
          <Row>
            <CaptionDiv>{messages.commission}</CaptionDiv>
            <CaptionDiv>
              <FormattedCurrency value={props.commission} />
            </CaptionDiv>
          </Row>
          <Separator />
        </>
      )}
      {country === 'BE' && (
        <>
          <Row>
            <CaptionDiv>{messages.including}</CaptionDiv>
            <div style={{ marginLeft: '6px', marginRight: 'auto' }}>
              <CaptionDiv>{messages.acquisitionFee}</CaptionDiv>
              <CaptionDiv>{messages.administrationFee}</CaptionDiv>
            </div>
            <div>
              <CaptionDiv>
                <FormattedCurrency value={props.acquisitionFees} />
              </CaptionDiv>
              <CaptionDiv>
                <FormattedCurrency value={props.administrationFees} />
              </CaptionDiv>
            </div>
          </Row>
          <Separator />
        </>
      )}
      <Row>
        <CaptionDiv>{messages.taxes}</CaptionDiv>
        <CaptionDiv>
          <FormattedCurrency value={props.taxes} />
        </CaptionDiv>
      </Row>
      <Separator />
      <Row>
        <CaptionDiv>{messages.toBePaid}</CaptionDiv>
        <CaptionDiv>
          <FormattedCurrency value={props.toBePaid} />
        </CaptionDiv>
      </Row>
    </>
  );
}
export function PriceTransparency(props: PriceTransparencyProps) {
  return (
    <Container className="price-transparancy-container">
      <PriceTransparencyInfo {...props} />
    </Container>
  );
}
